import React from 'react';

const Card = ({ children, className = '', forwardRef }) => (
  <div className={`card ${className}`} ref={forwardRef}>
    {children}
  </div>
);
export const CardHeader = ({ children, className = '' }) => (
  <div className={`card-header ${className}`}>{children}</div>
);
export const CardBody = ({ children, className = '' }) => (
  <div className={`card-body ${className}`}>{children}</div>
);
export const CardTitle = ({ children, className = '' }) => (
  <h5 className={`card-title ${className}`}>{children}</h5>
);
export const CardSubtitle = ({ children, className = '' }) => (
  <p className={`card-subtitle ${className}`}>{children}</p>
);
export const CardText = ({ children, className = '' }) => (
  <p className={`card-text ${className}`}>{children}</p>
);

export default Card;
